import React, { FC, FormEvent } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// components
import CustomDialog from '../components/CustomDialog';
import ActionButtons from '../components/ActionButtons';
import OutlinedInputController from 'controllers/outlined-input-controller';
import StyledForm from 'components/styled-form';
// custom hooks
import { useCatchServerError } from 'hooks/useCatchServerError';
// api
import { useCreateProjectLocationsMutation } from 'redux-store/api/project-location';
// validation
import { AddLocationSchema } from '../validation';

interface IAddLocationModalProps {
  open: boolean;
  projectId: number;
  handleClose: () => void;
  onAdd?: (value: number) => void;
}

export interface IFormValues {
  title: string;
}

const AddLocationModal: FC<IAddLocationModalProps> = ({ handleClose, open, projectId, onAdd }) => {
  const { catchError } = useCatchServerError();

  const form = useForm<IFormValues>({
    defaultValues: {
      title: '',
    },
    resolver: yupResolver(AddLocationSchema),
  });

  const [createLocation, { isLoading }] = useCreateProjectLocationsMutation();

  const onClose = () => {
    handleClose();
    form.reset();
  };

  const onSubmit = (formValues: IFormValues) => {
    createLocation({ projectId, ...formValues })
      .unwrap()
      .then((response) => {
        onAdd?.(response.id);
        onClose();
      })
      .catch(catchError);
  };

  const onFormSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.stopPropagation();
    form.handleSubmit(onSubmit)(event);
  };

  return (
    <CustomDialog
      title="Custom"
      subtitle="Add a custom item location for this project below. Go to Default Settings >> Item Locations to add new one to all projects."
      open={open}
      handleClose={onClose}
      handleBack={handleClose}
      withBackBtn={true}
    >
      <FormProvider {...form}>
        <StyledForm onSubmit={onFormSubmit}>
          <OutlinedInputController
            name="title"
            label="Item Location"
            fullWidth
            withError
            placeholder="Enter custom name"
          />
          <ActionButtons handleClose={onClose} label="save" loading={isLoading} />
        </StyledForm>
      </FormProvider>
    </CustomDialog>
  );
};

export default AddLocationModal;
